import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IAtendimentoDomiciliarForm } from "../../../../types/agendamento";

export const useAtualizarEnderecoAtendimento = () => {
  return useMutation({
    mutationFn: (data: IAtendimentoDomiciliarForm) =>
      Agendamento.putAddress(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
